import { addProp } from "@pnp/odata";
import { _Group } from "../groups/types.js";
import { Conversations, Senders } from "./types.js";
addProp(_Group, "conversations", Conversations);
addProp(_Group, "acceptedSenders", Senders, "acceptedsenders");
addProp(_Group, "rejectedSenders", Senders, "rejectedsenders");
//# sourceMappingURL=groups.js.map